var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"submit","disabled":!_vm.enabled}},[_vm._v("\n  "+_vm._s(_vm.lang.get('users.buttons.send_invite'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }